<template>
  <naj-box :title="title">
    <v-row>
      <v-col cols="12">
        <slot />
      </v-col>
    </v-row>
    <template v-if="showInputs">
      <v-row>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.address.country"
            :value.sync="formModel.countryId"
            :value-name.sync="formModel.country"
            :items="countries"
            item-text="name"
            item-value="id"
            validates="required"
            :disabled="!countries.length"
            @change="countryChanged"
          ></naj-input>
        </v-col>
        <v-col
          v-if="formModel.countryId == countriesEnum.saudiArabia"
          cols="3"
        >
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.address.region"
            :value.sync="formModel.regionId"
            :value-name.sync="formModel.region"
            :items="regions"
            item-text="name"
            item-value="id"
            validates="required"
            :disabled="!regions.length || !formModel.countryId"
            @change="regionChanged"
          ></naj-input>
        </v-col>
        <v-col
          v-else
          cols="3"
        >
          <naj-input
            :type-id="formFieldType.text"
            :label="local.address.region"
            :value.sync="formModel.region"
            validates="required"
          ></naj-input>
        </v-col>

        <v-col
          v-if="formModel.countryId == countriesEnum.saudiArabia"
          cols="3"
        >
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.address.city"
            :value.sync="formModel.cityId"
            :value-name.sync="formModel.city"
            :items="subCities[formModel.regionId]"
            item-text="name"
            item-value="id"
            validates="required"
            :disabled="!(subCities[formModel.regionId] || []).length || !formModel.regionId"
            @change="cityChanged"
          ></naj-input>
        </v-col>
        <v-col
          v-else
          cols="3"
        >
          <naj-input
            :type-id="formFieldType.text"
            :label="local.address.city"
            :value.sync="formModel.city"
            validates="required"
          ></naj-input>
        </v-col>
        <v-col
          v-if="formModel.countryId == countriesEnum.saudiArabia"
          cols="3"
        >
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.address.district"
            :value.sync="formModel.districtId"
            :value-name.sync="formModel.district"
            :items="districts[formModel.cityId]"
            item-text="name"
            item-value="id"
            :validates="(districts[formModel.cityId] || []).length && required ? 'required' : ''"
            :disabled="!(districts[formModel.cityId] || []).length || !formModel.cityId"
            @change="districtChanged"
          ></naj-input>
        </v-col>
        <v-col
          v-else
          cols="3"
        >
          <naj-input
            :type-id="formFieldType.text"
            :label="local.address.district"
            :value.sync="formModel.district"
            :validates="`${required ? 'required' : ''}`"
          ></naj-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :label="local.address.street"
            :value.sync="formModel.street"
            :validates="`${required ? 'required|' : ''}arabic`"
          ></naj-input>
        </v-col>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.number"
            :label="local.address.buildingNumber"
            :value.sync="formModel.buildingNumber"
          ></naj-input>
        </v-col>

        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.number"
            :label="local.address.flatNumber"
            :value.sync="formModel.flatNumber"
          ></naj-input>
        </v-col>
      </v-row>
    </template>
    <!-- <naj-button type="success" class="get-map-address">{{ local.address.specifyAddressonMap }}</naj-button> -->
  </naj-box>
</template>

<script>
import { countriesEnum, professionTypeEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';

const { mapActions, mapState } = createNamespacedHelpers('LookupsModule');

export default {
  inject: ['$validator'],
  name: 'NajAddress',
  props: {
    title: { required: true },
    formModel: { required: true },
    required: { required: false },
    showInputs: { default: true },
  },
  data() {
    return {
      countriesEnum,
      professionTypeEnum,
    };
  },
  computed: { ...mapState(['countries', 'subCities', 'districts', 'regions']) },
  watch: {
    showInputs(newValue) {
      !newValue && this.resetForm();
    },
  },
  created() {
    this.getCountries();
    this.getRegions();
    setTimeout(() => {
      if (this.formModel.regionId) {
        this.getCitiesByRegion(this.formModel.regionId);
      }
      if (this.formModel.cityId) {
        this.getDistrictsByCity(this.formModel.cityId);
      }
    }, 0);
  },
  methods: {
    ...mapActions([
      'getCountries',
      'getRegions',
      'getDistrictsByCity',
      'getCitiesByRegion',
    ]),
    countryChanged(value) {
      if (value) {
        this.$set(this.formModel, 'regionId', null);
        this.$set(this.formModel, 'region', null);
      }
    },
    regionChanged(value) {
      if (value) {
        this.getCitiesByRegion(value);
        this.$set(this.formModel, 'cityId', null);
        this.$set(this.formModel, 'city', null);
      }
    },
    cityChanged(value) {
      if (value) {
        this.getDistrictsByCity(value);
        this.$set(this.formModel, 'districtId', null);
        this.$set(this.formModel, 'district', null);
      }
    },
    resetForm() {
      this.$set(this.formModel, 'countryId', undefined);
      this.$set(this.formModel, 'regionId', undefined);
      this.$set(this.formModel, 'region', undefined);
      this.$set(this.formModel, 'cityId', undefined);
      this.$set(this.formModel, 'city', undefined);
      this.$set(this.formModel, 'districtId', undefined);
      this.$set(this.formModel, 'district', undefined);
      this.$set(this.formModel, 'street', undefined);
      this.$set(this.formModel, 'buildingNumber', undefined);
      this.$set(this.formModel, 'flatNumber', undefined);
    },
  },
};
</script>
